<wiz-hgroup height="100%" width="100%" verticalAlign="center" (dblclick)="addPart($event)">
  <wiz-label [wizLabel]="data.fullLabel" [wizTextBehavior]="'truncate'"></wiz-label>
  <wiz-icon style="cursor: pointer" (click)="addPart($event)">arrow-right</wiz-icon>
</wiz-hgroup>
